import React from 'react';
import {t} from '@lingui/core/macro';

import {IMassOperationAction} from 'shared/ui/MassOperations/MassOperations';
import {CheckInterval, GeoCheck, EditableFieldRow, MonitorBatchOperationsForm} from 'entities/monitor';
import {BATCH_EDIT_FIELD_BY_KEY, BATCH_EDIT_FIELDS} from 'features/http/lib/batchEditFields';
import useHttpMonitorBatchOperationsForm from 'features/http/model/useHttpMonitorBatchOperationsForm';

import RequestMethod from './RequestMethod/RequestMethod';
import RequestHeadersField from './RequestHeadersField/RequestHeadersField';
import RequestTimeout from './RequestTimeout/RequestTimeout';
import CheckboxBlock from './CheckboxBlock/CheckboxBlock';
import NotifySettingsSubform from './NotifySettingsSubform/NotifySettingsSubform';

interface IHttpMonitorBatchOperationsFormProps {
    handleClose: () => void,
    action?: IMassOperationAction,
    onSuccess?: () => void,
}

const HttpMonitorBatchOperationsForm: React.FC<IHttpMonitorBatchOperationsFormProps> = ({
    handleClose,
    action,
    onSuccess,
}) => {
    const state = useHttpMonitorBatchOperationsForm({actionValue: action?.value, handleClose, onSuccess});
    const {form, freeTariff, removeField} = state;
    const {register, formState, control, setValue, getValues, watch} = form;
    const {errors} = formState;

    const renderEditField = (key: string) => {
        switch (key) {
            case 'check_interval':
                return (
                    <EditableFieldRow key={key} onRemove={() => removeField(key)}>
                        <CheckInterval item={undefined} setValue={setValue} errors={errors} watch={watch}/>
                    </EditableFieldRow>
                );
            case 'method':
                return (
                    <EditableFieldRow key={key} onRemove={() => removeField(key)}>
                        <RequestMethod register={register} isFreeTariff={freeTariff} watch={watch}/>
                    </EditableFieldRow>
                );
            case 'http_request_timeout':
                return (
                    <EditableFieldRow key={key} onRemove={() => removeField(key)}>
                        <RequestTimeout setValue={setValue}/>
                    </EditableFieldRow>
                );
            case 'locations':
                return (
                    <EditableFieldRow key={key} onRemove={() => removeField(key)}>
                        <GeoCheck control={control} setValue={setValue}/>
                    </EditableFieldRow>
                );
            case 'notify':
                return (
                    <EditableFieldRow
                        key={key}
                        label={BATCH_EDIT_FIELD_BY_KEY.notify.label()}
                        onRemove={() => removeField(key)}
                    >
                        <NotifySettingsSubform control={control} register={register}/>
                    </EditableFieldRow>
                );
            case 'headers':
                return (
                    <RequestHeadersField
                        key={key}
                        control={control}
                        register={register}
                        selective
                        onRemove={() => removeField(key)}
                    />
                );
            default:
                return (
                    <CheckboxBlock
                        key={key}
                        getValues={getValues}
                        control={control}
                        register={register}
                        setValue={setValue}
                        activeKeys={[key]}
                        onRemoveField={removeField}
                    />
                );
        }
    };

    return (
        <MonitorBatchOperationsForm
            action={action}
            state={state}
            edit={{fields: BATCH_EDIT_FIELDS, renderField: renderEditField}}
            selectedLabel={t`Выбрано сайтов`}
        />
    );
};

export default HttpMonitorBatchOperationsForm;
